import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect } from 'react'
import { Table } from 'react-bootstrap-v5'
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { Link, useHistory } from 'react-router-dom'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Accordion from 'react-bootstrap/Accordion'

interface warehouseTransferItemRows  {
    idItems: number;
    quantity: number;
    transferQty?: number;
    excludingRate: number;
    amount: number;
    rate: number;
    [key: string]: any;
};

interface Item  {
    idItems: number;
    itemName: string;
    unitName: string;
    label?: string;
    value?: number;
    totalStockQuantity?: any;
};

interface Product  {
    id_products: number;
    name_value: string;
    packing: string;
    item_unit_name: string;
    id_product_group_alternate_names: number;
    sale_per_unit: number;
    label: string;
    value: string;
    unitRate: number;
    totalStockQuantity?: any;
    transferQty?: number;
};

interface TransferData {
    idProjects: number
    idWarehousesFrom: number;
    idWarehousesTo: number;
    transferDate: string;
    remarks: string;

}

type Warehouse = {
    id: number;
    name: string;
    label?: string;
    value?: number;
};

const WarehouseTransferCreate = () => {
    const [products, setProducts] = useState<Product[]>([]);
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
    const history = useHistory()

    const transferData: TransferData = {
        idProjects: 0,
        idWarehousesFrom: 0,
        idWarehousesTo: 0,
        transferDate: '',
        remarks: '',
    }

    const [projects, setProjects] = useState([])
    const [project, setProject] = useState({ label: 'Select Project', value: '' })
    const [warehouseTransfer, setWarehouseTransfer] = useState(transferData)
    const [warehouses, setWarehouses] = useState<Warehouse[]>([])
    const [warehouseFrom, setWarehouseFrom] = useState<{ label: string; value: number | '' }>({ label: 'Select Warehouse From', value: '' })
    const [warehouseTo, setWarehouseTo] = useState<{ label: string; value: number | '' }>({ label: 'Select Warehouse To', value: '' })
    const [warehouseTransferItemRows, setWarehouseTransferRows] = useState<warehouseTransferItemRows[]>([])


    const [items, setItems] = useState<Item[]>([])

    useEffect(() => {
        getProjects();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name
                    item.value = item.id
                    return item
                })
                setProjects(projectObj)
                if (projectObj.length > 0) {
                    setProject(projectObj[0])
                    setWarehouseTransfer({ ...warehouseTransfer, idProjects: projectObj[0].value })
                    getWarehouses(projectObj[0].value)
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const getWarehouses = (idProjects: number) => {
        if (!idProjects) {
            setWarehouses([])
            setWarehouseFrom({ label: 'Select Warehouse', value: '' })
            setWarehouseTo({ label: 'Select Warehouse', value: '' })
            return
        }

        fetch(
            process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success && Array.isArray(resp.data)) {
                    const warehouseOptions = resp.data.map((item: any) => ({
                        label: item.name,
                        value: item.id_warehouses
                    }))
                    setWarehouses(warehouseOptions)
                    if (warehouseOptions.length > 0) {
                        setWarehouseFrom(warehouseOptions[0])
                        setWarehouseTo(warehouseOptions.length > 1 ? warehouseOptions[1] : warehouseOptions[0])
                    } else {
                        setWarehouseFrom({ label: 'Select Warehouse', value: '' })
                        setWarehouseTo({ label: 'Select Warehouse', value: '' })
                    }
                } else {
                    setWarehouses([])
                    setWarehouseFrom({ label: 'Select Warehouse', value: '' })
                    setWarehouseTo({ label: 'Select Warehouse', value: '' })
                }
            })
            .catch(() => {
                setWarehouses([])
                setWarehouseFrom({ label: 'Select Warehouse', value: '' })
                setWarehouseTo({ label: 'Select Warehouse', value: '' })
            })
    }

    const handleProjectChange = (project: any) => {
        setProject(project)
        setWarehouseTransfer({ ...warehouseTransfer, idProjects: project.value })
        getWarehouses(project.value)
    }

    const handleItemChange = (data: any, index: number) => {
        const updatedWarehouseTransferItemRows = [...warehouseTransferItemRows]
        updatedWarehouseTransferItemRows[index].idItems = data.value
        updatedWarehouseTransferItemRows[index].excludingRate = 0
        setWarehouseTransferRows(updatedWarehouseTransferItemRows)
    }

    const getItemsForWarehouse = (projectId: number, warehouseId: number) => {
        fetch(
            process.env.REACT_APP_API_URL + 'warehouse-transfer/items?id_projects=' + projectId + '&id_warehouses=' + warehouseId,
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let items = resp.data.map((item: any) => {
                    item.label = item.itemName
                    item.value = item.idItems
                    item.totalStockQuantity = Number(item.total_stock_in) - Number(item.total_stock_out)
                    return item
                })
                setItems(items)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedWarehouseTransferItemRows = [...warehouseTransferItemRows]
        updatedWarehouseTransferItemRows[index][e.target.name] = e.target.value
        setWarehouseTransferRows(updatedWarehouseTransferItemRows)
        calculateSummary()
    }

    const deleteItem = (index: number) => {
        const updatedWarehouseTransferItemRows = [...warehouseTransferItemRows]
        if (updatedWarehouseTransferItemRows && updatedWarehouseTransferItemRows[index]) {
            updatedWarehouseTransferItemRows.splice(index, 1)
            setWarehouseTransferRows(updatedWarehouseTransferItemRows)
        }
    }

    const addItem = (index: number) => {
        const newRow: warehouseTransferItemRows = {
            idItems: 0,
            quantity: 0,
            excludingRate: 0,
            amount: 0,
            discountAmount: 0,
            carryingCost: 0,
            totalAmount: 0,
            rate: 0,
        }
        const updatedRows = [...warehouseTransferItemRows]
        updatedRows.push(newRow)
        setWarehouseTransferRows(updatedRows)
    }

    const handleInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setWarehouseTransfer({ ...warehouseTransfer, [event.target.name]: event.target.value })
    }

    const calculateSummary = async () => {
        if (!warehouseTransferItemRows.length) return

        warehouseTransferItemRows.forEach((row) => {
            row.amount = Number(row.excludingRate) * Number(row.quantity)
            row.discountAmount = Number(row.discountAmount)
            row.carryingCost = Number(row.carryingCost)
            row.totalAmount = row.amount - row.discountAmount + row.carryingCost
            row.rate = row.quantity > 0 ? (row.amount - row.discountAmount + row.carryingCost) / row.quantity : row.excludingRate
        })

    }

    const getProductsForWarehouse = (projectId: number, warehouseId: number) => {
        fetch(
            process.env.REACT_APP_API_URL + 'warehouse-transfer/products?id_projects=' + projectId + '&id_warehouses=' + warehouseId,
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let products = resp.data.map((item: any) => ({
                    ...item,
                    label: item.name_value + ' (' + item.packing + ' ' + item.item_unit_name + ')',
                    value: item.id_products + '-' + item.id_product_group_alternate_names,
                    unitRate: item.sale_per_unit,
                    totalStockQuantity: Number(item.total_stock_in) - Number(item.total_stock_out)
                }));
                setProducts(products);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }


    const addProductItem = () => {
        setSelectedProducts([...selectedProducts, '']);
    };

    const deleteProductItem = (index: number) => {
        const updatedProducts = [...selectedProducts];
        updatedProducts.splice(index, 1);
        setSelectedProducts(updatedProducts);
    };


    const handleProductChange = (selected: any, index: number) => {
        const updatedProducts = [...selectedProducts];
        updatedProducts[index] = selected.value;
        setSelectedProducts(updatedProducts);
    };

    const warehouseTransferSave = async (event: any) => {
        event.preventDefault()
        
        // Validation: Check if From and To warehouses are the same
        if (warehouseFrom.value === warehouseTo.value) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Source warehouse and destination warehouse cannot be the same.',
            });
            return;
        }

        // Validation: Check if both warehouses are selected
        if (!warehouseFrom.value || !warehouseTo.value) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please select both source and destination warehouses.',
            });
            return;
        }

        if (!warehouseTransfer.transferDate) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please select transfer date.',
            });
            return;
        }

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to create this stock transfer?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Create it!',
        })
        if (confirm.value) {
            // Prepare selectedProducts as array of product objects
            const selectedProductRows = selectedProducts
                .map((selectedValue) => {
                    const prod = products.find(p => p.value === selectedValue);
                    if (prod && prod.transferQty > 0) {
                        return {
                            id_products: prod.id_products,
                            id_product_group_alternate_names: prod.id_product_group_alternate_names,
                            transferQty: Number(prod.transferQty),
                            unitRate: prod.unitRate,
                            name_value: prod.name_value,
                            packing: prod.packing,
                            item_unit_name: prod.item_unit_name,
                        };
                    }
                    return null;
                })
                .filter(Boolean);

            // Convert transferQty to number for each item row
            const itemRowsWithQty = warehouseTransferItemRows.map(row => ({
                ...row,
                transferQty: Number(row.transferQty || 0)
            }));

            const transferPayload = {
                ...warehouseTransfer,
                idProjects: Number(project.value),
                idWarehousesFrom: Number(warehouseFrom.value),
                idWarehousesTo: Number(warehouseTo.value),
            };

            const postData = {
                warehouseTransfer: transferPayload,
                warehouseTransferItemRows: itemRowsWithQty,
                products: selectedProductRows,
            }
            const requestOptions = postRequestOptions(postData)
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}warehouse-transfer`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })
                    history.push("/warehouse-transfers")
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    })
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/svg/icons/Home/Book-open.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        Stock Transfer Create
                    </span>
                </div>
            </div>
            <div className="ml-12">
                <div className="card-body">
                    <form onSubmit={warehouseTransferSave}>
                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Select Project <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="warehouseFrom" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Warehouse From <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={warehouseFrom}
                                    onChange={(selected) => {
                                        setWarehouseFrom(selected);
                                        // If the selected 'To' warehouse is the same as 'From', clear the 'To' selection
                                        if (warehouseTo.value === selected?.value) {
                                            setWarehouseTo({ label: 'Select Warehouse To', value: '' });
                                        }
                                        // Load items and products when warehouse from is selected
                                        if (selected?.value && project.value) {
                                            getItemsForWarehouse(project.value, selected.value);
                                            getProductsForWarehouse(project.value, selected.value);
                                        }
                                    }}
                                    options={warehouses}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={warehouses.length === 0}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="warehouseTo" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Warehouse To <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={warehouseTo}
                                    onChange={(selected) => setWarehouseTo(selected)}
                                    options={warehouses.filter(wh => wh.value !== warehouseFrom.value)}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={warehouses.length === 0}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="transferDate" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>
                                Transfer Date <span className="required text-danger"></span>
                            </label>
                            <div className="col-lg-5">
                                <input
                                    type='date'
                                    name="transferDate"
                                    id="transferDate"
                                    onChange={handleInputOnChange}
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Remarks</label>
                            <div className="col-lg-5">
                                <input name="remarks" id="remarks" onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>
                        <Accordion defaultActiveKey={['0', '1']} alwaysOpen>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Items</Accordion.Header>
                                <Accordion.Body>
                                    <div className="row">
                                        <div className="col">
                                            <Table size='sm' bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '5%' }} className='text-center'>SL</th>
                                                        <th style={{ width: '10%' }}>Item Name <span className='text-danger'>*</span> </th>
                                                        <th style={{ width: '5%' }}>Unit <span className='text-danger'>*</span> </th>
                                                        <th style={{ width: '10%' }}>Rate</th>
                                                        <th style={{ width: '10%' }}>Stock Quantity</th>
                                                        <th style={{ width: '10%' }}>Quantity</th>
                                                        <th style={{ width: '5%' }}></th>
                                                        <th style={{ width: '5%' }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {warehouseTransferItemRows.map((row, index) => (
                                                    <tr key={'item-' + index}>
                                                        <td className='text-center'>{index + 1}</td>
                                                        <td>
                                                            <Select
                                                                placeholder={row.itemName}
                                                                onChange={(selectedOption) => handleItemChange(selectedOption, index)}
                                                                options={items}
                                                                className='sm'
                                                                menuPosition="fixed"
                                                                styles={{
                                                                    control: (provided) => ({
                                                                        ...provided,
                                                                        height: '32px',
                                                                        minHeight: '32px',
                                                                    }),
                                                                    container: (provided) => ({
                                                                        ...provided,
                                                                        height: '32px',
                                                                    }),
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input type="text" name="unitName" value={items.find(item => item.idItems === row.idItems)?.unitName} readOnly className="form-control form-control-sm" />
                                                        </td>
                                                        <td>
                                                            <input type="number" name="excludingRate" value={row.excludingRate} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" readOnly />
                                                        </td>
                                                        <td>
                                                            {/* Stock Quantity: Show in red if negative */}
                                                            <span style={{ 
                                                                color: (items.find(item => item.idItems === row.idItems)?.totalStockQuantity || 0) < 0 ? 'red' : 'inherit' 
                                                            }}>
                                                                {items.find(item => item.idItems === row.idItems)?.totalStockQuantity || ''}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <input type="number" name="transferQty" value={row.transferQty} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                                        </td>
                                                        <td>
                                                            <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteItem(index)}>
                                                                <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    ))}
                                                    {warehouseTransferItemRows.length === 0 && (
                                                        <tr>
                                                            <td colSpan={8} className='text-center'>No items added</td>
                                                        </tr>
                                                    )}
                                                    <tr>
                                                        <td colSpan={8} className='text-end'>
                                                            <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addItem(0)}>
                                                                <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                    
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Products</Accordion.Header>
                                <Accordion.Body>
                                    {/* Products Block */}
                                    <Table size='sm' bordered hover>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '5%' }} className='text-center'>SL</th>
                                                <th style={{ width: '35%' }}>Product Name <span className='text-danger'>*</span></th>
                                                <th style={{ width: '15%' }}>Rate</th>
                                                <th style={{ width: '15%' }}>Stock Quantity</th>
                                                <th style={{ width: '15%' }}>Quantity</th>
                                                <th style={{ width: '15%' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedProducts.map((selectedValue, index) => {
                                                const selectedProduct = products.find(p => p.value === selectedValue) || {};
                                                return (
                                                    <tr key={'product-' + index}>
                                                        <td className='text-center'>{index + 1}</td>
                                                        <td>
                                                            <Select
                                                                value={selectedProduct.value ? selectedProduct : null}
                                                                onChange={(selected) => handleProductChange(selected, index)}
                                                                options={products}
                                                                menuPosition="fixed"
                                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                            />
                                                        </td>
                                                        <td>
                                                            {selectedProduct.unitRate || ''}
                                                        </td>
                                                        <td>
                                                            <span style={{ 
                                                                color: (selectedProduct.totalStockQuantity || 0) < 0 ? 'red' : 'inherit' 
                                                            }}>
                                                                {selectedProduct.totalStockQuantity || ''}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className="form-control form-control-sm"
                                                                value={selectedProduct.transferQty || ''}
                                                                onChange={e => {
                                                                    const prodIndex = products.findIndex(p => p.value === selectedValue);
                                                                    if (prodIndex > -1) {
                                                                        products[prodIndex].transferQty = e.target.value;
                                                                        setProducts([...products]);
                                                                    }
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteProductItem(index)}>
                                                                <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            {selectedProducts.length === 0 && (
                                                <tr>
                                                    <td colSpan={6} className='text-center'>No products added</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td colSpan={6} className='text-end'>
                                                    <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addProductItem()}>
                                                        <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <button type="submit" className="btn btn-sm btn-primary me-2">
                                    <span>Save</span>
                                </button>
                                <Link to='/po' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default WarehouseTransferCreate;